"use strict";

var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.totalPendingOrders = exports.totalOutstanding = exports.totalFySales = exports.totalFyPayment = exports.totalCurrentRecievable = exports.totalCollection = exports.topSellingProducts = exports.topDealers = exports.getPreviousMonthSales = exports.getPreviousMonthPayments = exports.getOverdueByDays = exports.getLast3DaysAddedUsers = exports.getDailyOrderValue = exports.getCurrentMonthSales = exports.getCurrentMonthPayments = exports.getCurrentMonthOrderValue = exports.getAverageSales = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const topSellingProducts = params => (0, _request.default)({
  url: '/reports/item-wise-report',
  method: 'get',
  params
});
exports.topSellingProducts = topSellingProducts;
const topDealers = params => (0, _request.default)({
  url: '/reports/sales-report',
  method: 'get',
  params
});
exports.topDealers = topDealers;
const totalOutstanding = params => (0, _request.default)({
  url: '/orders-dispatches/outstanding-total',
  method: 'get',
  params
});
exports.totalOutstanding = totalOutstanding;
const totalCollection = data => (0, _request.default)({
  url: '/orders-dispatches/collection',
  method: 'post',
  data
});
exports.totalCollection = totalCollection;
const totalFySales = params => (0, _request.default)({
  // url: '/orders-dispatches/fy-sales-value',
  url: '/reports/fy-sales',
  method: 'get',
  params
});
exports.totalFySales = totalFySales;
const getAverageSales = params => (0, _request.default)({
  url: '/reports/average-sales',
  method: 'get',
  params
});
exports.getAverageSales = getAverageSales;
const totalFyPayment = params => (0, _request.default)({
  // url: 'ledgers/fy-payments',
  url: 'reports/fy-payments',
  method: 'get',
  params
});
exports.totalFyPayment = totalFyPayment;
const totalCurrentRecievable = params => (0, _request.default)({
  url: 'orders-dispatches/current-recievable',
  method: 'get',
  params
});
exports.totalCurrentRecievable = totalCurrentRecievable;
const totalPendingOrders = params => (0, _request.default)({
  url: 'orders/total-order-pending',
  method: 'get',
  params
});
exports.totalPendingOrders = totalPendingOrders;
const getCurrentMonthSales = params => (0, _request.default)({
  url: '/orders-dispatches/current-month-sales',
  method: 'get',
  params
});
exports.getCurrentMonthSales = getCurrentMonthSales;
const getCurrentMonthPayments = params => (0, _request.default)({
  url: '/ledgers/current-month-payment',
  method: 'get',
  params
});
exports.getCurrentMonthPayments = getCurrentMonthPayments;
const getPreviousMonthSales = params => (0, _request.default)({
  url: '/orders-dispatches/previous-month-sales',
  method: 'get',
  params
});
exports.getPreviousMonthSales = getPreviousMonthSales;
const getPreviousMonthPayments = params => (0, _request.default)({
  url: '/ledgers/previous-month-payment',
  method: 'get',
  params
});
exports.getPreviousMonthPayments = getPreviousMonthPayments;
const getDailyOrderValue = params => (0, _request.default)({
  url: '/orders/daily-order-value',
  method: 'get',
  params
});
exports.getDailyOrderValue = getDailyOrderValue;
const getCurrentMonthOrderValue = params => (0, _request.default)({
  url: '/orders/current-month-order-value',
  method: 'get',
  params
});
exports.getCurrentMonthOrderValue = getCurrentMonthOrderValue;
const getOverdueByDays = data => (0, _request.default)({
  url: '/orders-dispatches/overdue-by-days',
  method: 'post',
  data
});
exports.getOverdueByDays = getOverdueByDays;
const getLast3DaysAddedUsers = params => {
  return (0, _request.default)({
    url: '/dealers-users/last-3-days-created-users',
    method: 'get',
    params
  });
};
exports.getLast3DaysAddedUsers = getLast3DaysAddedUsers;